import dayjs from "dayjs";
import I18n from "common/i18n";

interface SessionDividerProps {
  type: "start" | "end";
  timestamp?: string;
}

export const SessionDivider = ({ type, timestamp }: SessionDividerProps) => {
  const label =
    type === "start"
      ? timestamp
        ? `${dayjs(timestamp).format("MM/DD HH:mm")} ${I18n.t("MSG_AI_CHAT_SESSION_START")}`
        : I18n.t("MSG_AI_CHAT_SESSION_START")
      : I18n.t("MSG_AI_CHAT_SESSION_END");

  return (
    <div className="flex flex-row items-center gap-2 py-3">
      <div className="flex-1 h-[1px] bg-gray-20" />
      <p className="text text-gray2-100 !text-[18px] !leading-[24px] px-2">{label}</p>
      <div className="flex-1 h-[1px] bg-gray-20" />
    </div>
  );
};
